import React from "react";
import { NavLink } from "react-router-dom";
import { routes } from "../../../routes"
import { useRole } from "../../../hooks/useRole";
const SideBar = () => {


  const role = useRole();
  

  function generateSidebar(route: any) {
  
     
    if (route.children.length > 0) {
      if(route.ishidden == true || route.perm != role) return ;
      return (
        <li className="nav-item" key={Math.floor(Math.random() * 100)}>
          <a className="nav-link collapsed" data-bs-target={`#${route.title}-nav`} data-bs-toggle="collapse" href="#">
            <i className={route.icon}></i><span>{route.title}</span><i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul id={`${route.title}-nav`} className="nav-content collapse " data-bs-parent="#sidebar-nav">
            {route.children.map((child: any , index: number) => {

              if (child.children.length > 0) {
                // here make sub menu 
                //  return <>{generateSidebar(child)}</> 
              } else {
                if(child.ishidden == true  || child.perm != role) return ;
                return (
                  <li key={index}>
                    <NavLink to={child.path}
                      style={({ isActive }) => ({
                        color: isActive ? "red" : "green"
                      })}
                    >
                      <i className="bi bi-circle"></i><span>{child.title}</span>
                    </NavLink>
                  </li>
                )
              }
            })}



          </ul>
        </li>


      )
    } else {
      if(route.ishidden == true  || route.perm != role) return ;
      return (
        <li className="nav-item" key ={Math.floor(Math.random() * 100)} >
          <NavLink className="nav-link " to={route.path}>
            <i className={route.icon}></i>
            <span>{route.title}</span>
          </NavLink>
        </li>

      )
    }

  }
  console.log(routes);

  return (
    <>


      <aside id="sidebar" className="sidebar">

        <ul className="sidebar-nav" id="sidebar-nav">
          {
            routes.map((route: any, index: any) => {

              return (
                <div key={index}>
                  {generateSidebar(route)}

                </div>
              )
            })

          }









        </ul>

      </aside>
    </>
  )
}

export default SideBar